import { ReactElement, useEffect } from 'react';
import { useUINav } from '@/ui';
import { useCompanyContext, useTeam } from '@/companies/providers';
import { TeamUsersList } from '@/companies/components';
import { usePagesTranslation } from '../../hooks';

export function TeamIdMembersSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { company } = useCompanyContext();
    const { team } = useTeam();

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            {
                text: t('shared.labels.teams'),
                link: `/company/${company.id}/settings/teams`
            },
            { text: team.name },
            { text: t('shared.labels.members') }
        ]);
    }, [setParts, company.id, team.name, t]);

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: 24
            }}
        >
            <TeamUsersList teamId={team.id} />
        </div>
    );
}
